<template>
  <!-- this is an example of a dynamic template. -->
  <!-- Your dynamic content is exposed as 'content' data property in the template. -->
  <div class="page">
    <div class="container">
      <div class="clearfix content">
          <div v-if="!currentContent">
            <div class="body">Loading...</div>
          </div>
          <div v-else >
            <div v-if="sections">
                <div class="page-intro-image">
                  <img :src="item.IntroImage"/>
                </div>
                <content-title :fieldClass="'title'" v-if="item.Title" :text="item.Title"/>
                <div class="page-intro-text">
                  <p>{{item.IntroText}}</p>
                </div>
              </div>
            <div class="each-section" v-else>
              <div class="section-page-intro-image">
                <img :src="item.IntroImage"/>
              </div>
              <div class="section-section">
                <h1 v-if="item.Title">{{item.Title}}</h1>
                <div class="page-intro-text">
                  <p>{{item.IntroText}}</p>
                </div>
                <div v-if="item.slug != 'sections'" class="button-container">
                    <a class="register-button" href="https://www.girlguiding.org.uk/information-for-parents/register-your-daughter/">
                    Register Now
                    </a>
                </div>
              </div>
            </div>
                <div class="page-content"><content-body v-if="item.PageContent" :fieldClass="'body'" :body="item.PageContent"/></div>    
                <div class="all-selections" v-if="sections">
                    <div class="section"  v-for="(section, index) in allSections" :key="index" >
                        <a :href="section.slug">
                            <div class="img-section">
                                <img :src="section.IntroImage" :alt="section.Title + 'header image'"/>
                            </div>
                            <div class="content-section">
                                <h2>{{section.Title}}</h2>
                                <p>{{section.IntroText}}</p>
                            </div>
                        </a>
                    </div>   
                </div>
                <div class="page-image"><content-image :src="item.Image" :fieldClass="'responsive-image'"/></div>    
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadContent from './LoadContent'
import Title from '@/app/fieldTemplates/Title.vue'
import Image from '@/app/fieldTemplates/Image.vue'
import Body from '@/app/fieldTemplates/Body.vue'
import _ from 'lodash'

export default {
  mixins: [LoadContent],
  components: {
    contentTitle: Title,
    contentImage: Image,
    contentBody: Body,
  },
  data() {
    return {
      item:{
        IntroImage: '',
        IntroText: '',
        PageContent: '',
        Title: ''
      },
      sections: false
    }
  },
  computed: {
    currentContent () {
      this.allSections = [];
      for(var i = 0; i < this.content.length; i++)
      {
        if(this.$route.path === '/'+this.content[i].slug)
        {
          this.item = this.content[i];
          if(this.$route.path === "/sections")
          {
              this.sections = true;
          }
          else
          {
              this.sections = false;
          }
        }
        else
        {
            this.allSections.push(this.content[i])
        }
      }
      return this.content;
    }
  },
  methods: {}
}
</script>

<style lang="scss">
@import '@/app/styles/index.scss';

.page-news {
  .news-title {
    margin-bottom: 5px;
  }
  .date {
    margin-bottom: 20px;
  }
  .subheadline {
    font-weight: 700;
    margin-bottom: 25px;
  }
  hr {
    margin: 30px 0 15px 0;
  }
  .share-box {
    .is-subheading {
      font-size: 20px;
    }
    ul {
      display: flex;
      margin-top: 10px;
      li {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
  .search-box {
    margin-bottom: 25px;
  }
}

@media (max-width: 768px) {
  .page-news {
    .rightbar {
      display: none;
    }
  }
}

@media (max-width: 600px) {
  .page-news {
    .search-box {
      margin: 10px 0;
      display: none;
    }
    .leftbar {
      margin-top: 10px;
    }
  }
}
.page-intro-image{
      height: auto;
    max-width: 1000px;
    margin: auto;
    display: flex;
    img{
      width: 100%;
    }
}
.page-intro-text{
  padding: 20px;
  text-align: center;
}
.page-image{
  max-width: 900px;
  margin: auto;
}
.page-content{
  padding: 20px;
}
.all-selections{
  width: 100%;
  max-width: 1200px;
  margin: auto;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content:center;
//   align-items:stretch;
  .section
  {
    a{
      font-size:15px;
      font-weight:300;
      color:black;
    }
  }
}
.section{
  flex: 2 2 20em;
  margin: 10px;
    padding: 0;
  // padding: 20px;
  width: auto;
  max-width: 500px;
  text-align: center;
  height: auto;
  border-radius: 10px;
  flex-grow: 1;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  display: flex;
  flex-wrap: wrap;
  
.img-section{
    // max-width: 500px;
}
}
.content-section{
    padding:20px;
}
.each-section{
  display:flex;
  display:-webkit-flex;
  flex-direction:row;
  flex-wrap:wrap;
  h3{
    color:white;
  }
}
.section-page-intro-image{
  flex: 1 1 20em;
    height: auto;
    // max-width: 500px;
    margin: auto;
    display: flex;
    img{
      width: 100%;
    }
}

.section-section {
    background-color:$color-pink;
  padding:10px;
  color:white;
  flex: 2 2 20em;
  display: flex;
    flex-direction: column;
    justify-content: center;
    h1{
      color:white;
      text-align:center;
    }
}
.register-button{
  color:white;
  border:solid 2px white;
  padding:10px 20px;
  margin:20px auto;
}
.button-container{
  display:flex;
  display:-webkit-flex;
}
</style>